import { RichTextAdvancedInput } from '@framework/engine';
import { CheckboxInput, FormItem, MenuPresets } from '@framework/form';
import { Card } from 'antd';

export interface IConfigCardPanelContainerProps {}

/**
 * Componente di configurazione del Pannello Grafico per i widget che lo supportano.
 *
 * Permette di configurare: showPanel e panelTitle.
 */
export function ConfigCardPanelContainer(
  props: IConfigCardPanelContainerProps,
) {
  return (
    <Card
      size="small"
      styles={{
        body: { paddingTop: 6, paddingBottom: 0 },
      }}
      title="Configura Pannello Grafico"
    >
      <FormItem name="showPanel" layout={{ removeLabelSpace: true }}>
        <CheckboxInput name="showPanel" defaultChecked={false}>
          Mostra Pannello con Cornice e Titolo
        </CheckboxInput>
      </FormItem>
      <FormItem name="panelTitle" label="Titolo del Pannello">
        <RichTextAdvancedInput
          name="panelTitle"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>
    </Card>
  );
}
